export default "__VITE_ASSET__BfHluhud__"